import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Heading,
  Container,
  Flex,
  Link,
  SimpleGrid,
  Icon
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

import { IoCall } from 'react-icons/io5';

import { useColorModeValue } from './chakra-ui/color-mode';
import SocialMediaLinks from './social-media';
import { COLORS } from '../theme';
import { PHONE_NUMBER, PHONE_LINK, CONTACT_QR_CODE_PATH } from '../constants/constants';

function ContactFooter() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const sectionBorder = useColorModeValue('gray.200', 'gray.800');
  const cardBg = useColorModeValue(COLORS.glass.bg.light, COLORS.glass.bg.dark);
  const cardBorder = useColorModeValue(
    COLORS.glass.border.light,
    COLORS.glass.border.dark
  );
  const cardShadow = useColorModeValue(
    COLORS.glass.shadow.light,
    COLORS.glass.shadow.dark
  );
  const year = new Date().getFullYear();

  return (
    <Box
      id="contact"
      bg={bgColor}
      borderTop={1}
      borderStyle="solid"
      borderColor={sectionBorder}
      pt={8}
      pb={8}
    >
      <Container maxW="container.xl">
        <VStack spacing={12} mb={8}>
          <VStack spacing={4} textAlign="center" mb={4}>
            <Heading size="2xl">
              Let's Create Something Beautiful Together
            </Heading>
            <Text fontSize="lg" color="gray.600" maxW="2xl">
              Ready to capture your special moments? Get in touch to discuss
              your photography needs and let's create stunning memories that
              will last a lifetime.
            </Text>
          </VStack>

          <SimpleGrid
            columns={{ base: 1, md: 1 }}
            spacing={8}
            w="full"
            maxW="4xl"
            gap={2}
          >
            {/* <VStack
              spacing={4}
              border={1}
              p={4}
              boxShadow="sm"
              bg={bgColor2}
              h={'100%'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <VStack spacing={1}>
                <Text fontWeight="semibold" fontSize="lg">
                  <Icon color={COLORS.brand.primary} boxSize={6} mr={1}>
                    <SiMinutemailer />
                  </Icon>{' '}
                  Email Us
                </Text>
                <Link
                  href="mailto:vian.photo27@gmail.com"
                  color={COLORS.brand.primary}
                >
                  vian.photo27@gmail.com
                </Link>
              </VStack>
            </VStack> */}

            <VStack
              spacing={4}
              p={4}
              borderRadius="2xl"
              boxShadow={cardShadow}
              bg={cardBg}
              backdropFilter={`blur(${COLORS.glass.blur})`}
              border="1px solid"
              borderColor={cardBorder}
              h={'100%'}
              justifyContent={'center'}
              alignItems={'center'}
              transition="all 0.3s"
            >
              <SimpleGrid columns={2} spacing={2} w="full">
                {/* Call Us Section */}
                <VStack spacing={1} justifyContent="center" alignItems="center">
                  <Text fontWeight="semibold" fontSize="lg">
                    <Icon color={COLORS.brand.primary} boxSize={6} mr={1}>
                      <IoCall />
                    </Icon>{' '}
                    Call Us
                  </Text>
                  <Link href={PHONE_LINK} color={COLORS.brand.primary}>
                    {PHONE_NUMBER}
                  </Link>
                </VStack>

                {/* QR Code Section */}
                <VStack spacing={2} justifyContent="center" alignItems="center">

                  <Box
                    as="img"
                    src={CONTACT_QR_CODE_PATH}
                    alt="Contact QR Code"
                    boxSize="120px"
                    borderRadius="md"
                  />
                </VStack>
              </SimpleGrid>
            </VStack>
          </SimpleGrid>

          {/* Social Media Links */}
          <VStack spacing={6} mt={4}>
            <VStack spacing={2} textAlign="center">
              <Text fontWeight="semibold" fontSize="lg">
                Follow Our Journey
              </Text>
              <Text color="gray.600">
                Stay connected for daily inspiration and behind-the-scenes
                content
              </Text>
            </VStack>

            <Box width={'100%'}>
              <SocialMediaLinks />
            </Box>

            {/* Add QR Codes Link */}
            <Box mt={4}>
              <Link
                as={RouterLink}
                to="/qr-codes"
                fontSize="sm"
                color="blue.500"
                _hover={{ textDecoration: "underline" }}
              >
                View Our QR Codes
              </Link>
            </Box>
          </VStack>
        </VStack>



        {/* Footer Bottom */}
        <Flex
          direction='column'
          justify="space-between"
          align="center"
          gap={4}
        >
          <Text color="gray.600">
            © {year} ViAn Photography. All rights reserved.
          </Text>
        </Flex>
      </Container>
      {/* Extra space for mobile iframe google sites */}
      <Box mb={30} height={'100px'}></Box>
    </Box>
  );
}
export default ContactFooter;
